import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import List from '../../../base/List';
import Typography from '../../../base/Typography';
import Facebook from '../../../icons/social/Facebook';
import Twitter from '../../../icons/social/Twitter';
import Linkedin from '../../../icons/social/Linkedin';
import Instagram from '../../../icons/social/Instagram';
import Youtube from '../../../icons/social/Youtube';
import { getColorForName } from '../../../theme/colors';

// eslint-disable-next-line import/prefer-default-export
export const HeadlineStyled = styled(Typography)`
${({ theme }) => {
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));

    return css`
    display: none;

    ${mediumUp && `
      display: block;
      margin-bottom: 0.5rem;
    `}
  `;
  }
}`;

export const ListStyled = styled(List)`
${({ theme }) => {
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));

    return css`
      margin-top: ${rem(32)};
      text-align: center;

      ${mediumUp && `
        margin-top: 0;
        text-align: left;
      `}
    `;
  }
}`;

const iconStyles = css`
.icon-fill {
    fill: ${getColorForName('color-neutral-gray-80')};
  }

  &:hover,
  &:focus {
    .icon-fill {
      fill: ${getColorForName('color-system-cta-hover-blue')};
    }
  }
`;
export const FacebookIconStyled = styled(Facebook)`${iconStyles}`;
export const TwitterIconStyled = styled(Twitter)`${iconStyles}`;
export const LinkedinIconStyled = styled(Linkedin)`${iconStyles}`;
export const InstagramIconStyled = styled(Instagram)`${iconStyles}`;
export const YoutubeIconStyled = styled(Youtube)`${iconStyles}`;

export const ListItemStyled = styled.li`
  margin-right: ${rem(5)};
`;
